import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-geomap-marker-status',
    templateUrl: './geomap-marker-status.component.html',
    styleUrls: ['./geomap-marker-status.component.scss'],
    standalone: false
})
export class GeomapMarkerStatusComponent implements OnInit {

  @Input() subAssets: any[];
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() redirectToSubAsset: EventEmitter<string> = new EventEmitter<string>();

  public showAll = false;
  public listLimit = 3;

  ngOnInit() {
    if (!this.subAssets) {
      this.subAssets = [];
    }
  }

  public toggleShowAll(): void {
    this.showAll = !this.showAll;
    this.changed.emit(this.showAll);
  }
}
